export const importMap = {
  'en-US': () => import('state/intl/translations/en.json'),
  'es-ES': () => import('state/intl/translations/es.json'),
  'pt-PT': () => import('state/intl/translations/pt.json'),
};
